import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'

import { eps } from './url.service'
import { Coupon } from '../store/coupon/coupon.state'

@Injectable({
  providedIn: 'root'
})
export class CouponService {
  private apiUrl = eps.superAdmin.couponsApi

  constructor(private http: HttpClient) {}

  // Get Coupons
  getCoupons(params?: string | null, page?: number, limit?: number): Observable<any> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<any>(url)
  }

  // Analytics
  getAnalytics(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/analytics`)
  }

  // Get By Id
  getCouponById(id: string): Observable<Coupon> {
    return this.http.get<Coupon>(`${this.apiUrl}/${id}`)
  }

  // Create
  addCoupon(coupon: Partial<Coupon>): Observable<Coupon> {
    return this.http.post<Coupon>(this.apiUrl, coupon)
  }

  // Update
  editCoupon(id: string, coupon: Partial<Coupon>): Observable<Coupon> {
    return this.http.put<Coupon>(`${this.apiUrl}/${id}`, coupon)
  }

  // Delete
  deleteCoupon(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`)
  }
}
